// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-frame[data-v-314b5ef4] {\n  width: 300px;\n}\n.system-simulation-refund[data-v-314b5ef4] {\n  margin: 20px;\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
